import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillPhishingCircle = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="12" height="12" rx="6" fill="#E44258" />
    <path
      d="M11 5.01624C11 4.45648 10.52 4 9.93333 4C9.34667 4 8.86667 4.45648 8.86667 5.01624C8.86667 5.46606 9.17667 5.84257 9.6 5.97918V9.70762C9.6 10.6006 8.71667 11.3303 7.63334 11.3303C6.55 11.3303 5.66667 10.6039 5.66667 9.70762V9.61766H7.05C7.18334 9.61766 7.30334 9.54102 7.35667 9.41774C7.41 9.29779 7.38667 9.15452 7.29667 9.05789L5.58 7.192C5.48667 7.09204 5.34 7.05873 5.21333 7.1087C5.08667 7.15868 5 7.28197 5 7.41858V9.28446C5 9.28446 5 9.2878 5 9.29113V9.71095C5 10.9738 6.18 12 7.63334 12C9.08667 12 10.2667 10.9738 10.2667 9.71095V5.97584C10.69 5.84257 11 5.46272 11 5.01291V5.01624ZM5.66667 8.94794V8.27155L6.29 8.94794H5.66667ZM9.93333 5.3661C9.71333 5.3661 9.53334 5.2095 9.53334 5.01624C9.53334 4.82299 9.71333 4.66639 9.93333 4.66639C10.1533 4.66639 10.3333 4.82299 10.3333 5.01624C10.3333 5.2095 10.1533 5.3661 9.93333 5.3661Z"
      fill="#fff"
    />
  </svg>
)

export default withDefaultStyles(FillPhishingCircle)
